import { createBrowserHistory } from "history";

interface IHistoryState {
    from: string;
}

export default createBrowserHistory<IHistoryState>();